import React from 'react';
import { Tooltip, Typography, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

type CopyTooltipProps = {
  text: string;
};

export const CopyTooltip: React.FC<CopyTooltipProps> = ({ text }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Tooltip
      title={
        <Stack onClick={handleCopy}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" sx={{ fontSize: '1em', cursor: 'pointer' }}>
              {text}
            </Typography>
            <ContentCopyIcon fontSize="small" sx={{ color: '#17B1E2', cursor: 'pointer' }} />
          </Stack>
        </Stack>
      }
    >
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          width: '100%',
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
};

export default CopyTooltip;
